// percent is the percent white to add
// negative values will shade (add black)
const hexParser = /#?((?:[a-f]|\d){2})((?:[a-f]|\d){2})((?:[a-f]|\d){2})/i
export const getTint = (color, percent) =>
  hexParser
    .exec(color)
    ?.slice(1)
    .map(c => parseInt(c, 16))
    .map(c => Math.round(
      percent >= 0
        ? c + (255 - c) * percent
        : c * (1 + percent)
    ))
    .map(c => c.toString(16).padStart(2, '0'))
    .reduce((a, b) => a + b, '#')
